import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHideSkeletonEdges = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeMiterlimit: 2,
	clipRule: "evenodd",
	viewBox: "0 0 20 20",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		strokeWidth: 1.13016,
		d: "M.001 7.979h4.045v4.044H.001zM7.98 7.979h4.046v4.044H7.98zM15.954 1.979h4.044v4.045h-4.044zM15.954 13.98h4.044v4.044h-4.044z"
	})
});
export default SvgIconHideSkeletonEdges;
